module.exports = __webpack_public_path__ + "img/icon_server_center_white.1c1f6f47.svg";